import { c as _c } from "react/compiler-runtime";
import React, { CSSProperties, useContext } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import { ModalContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(product-details)/components/ProductImageGallery/ProductImageGallery.tsx';
type ProductSliderImageItemProps = {
  url: string;
  alt: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
  className?: string;
  useZoom?: boolean;
  priority?: boolean;
  quality?: number;
};
function ProductSliderImageItem(t0) {
  const $ = _c(27);
  const {
    url,
    alt,
    width,
    height,
    className,
    useZoom: t1,
    priority: t2,
    quality: t3
  } = t0;
  const useZoom = t1 === undefined ? true : t1;
  const priority = t2 === undefined ? false : t2;
  const quality = t3 === undefined ? 100 : t3;
  const {
    onClick
  } = useContext(ModalContext);
  let t4;
  if ($[0] !== onClick || $[1] !== useZoom) {
    t4 = function onImageClick(e) {
      e.preventDefault();
      if (useZoom) {
        onClick();
      }
    };
    $[0] = onClick;
    $[1] = useZoom;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const onImageClick = t4;
  const t5 = width || 585;
  const t6 = height || 585;
  const t7 = width || 585;
  const t8 = height || 585;
  let t9;
  if ($[3] !== t7 || $[4] !== t8) {
    t9 = {
      width: t7,
      height: t8
    };
    $[3] = t7;
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== className) {
    t10 = classNames("object-contain max-h-[50vh] lg:max-h-none", className);
    $[6] = className;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== alt || $[9] !== priority || $[10] !== quality || $[11] !== t10 || $[12] !== t5 || $[13] !== t6 || $[14] !== t9 || $[15] !== url) {
    t11 = <Image width={t5} height={t6} src={url} alt={alt} style={t9} className={t10} priority={priority} quality={quality} />;
    $[8] = alt;
    $[9] = priority;
    $[10] = quality;
    $[11] = t10;
    $[12] = t5;
    $[13] = t6;
    $[14] = t9;
    $[15] = url;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const image = t11;
  let t12;
  if ($[17] !== className) {
    t12 = classNames("w-full flex justify-center items-center product-slider-image-item", className);
    $[17] = className;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== image || $[20] !== onImageClick || $[21] !== url || $[22] !== useZoom) {
    t13 = useZoom ? <a href={url} className={classNames("relative pointer-events-none md:pointer-events-auto", {
      "hover:cursor-zoom-in": useZoom
    })} onClick={onImageClick}>{image}</a> : <div className="relative">{image}</div>;
    $[19] = image;
    $[20] = onImageClick;
    $[21] = url;
    $[22] = useZoom;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}
export default ProductSliderImageItem;